"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParallelGateway = void 0;
const Constants_1 = require("../Constants");
const Gateway_1 = require("./Gateway");
/**
 * Describes a ParallelGateway.
 *
 * These gateways are used to run multiple branches in parallel.
 */
class ParallelGateway extends Gateway_1.Gateway {
    get bpmnType() {
        return Constants_1.BpmnType.parallelGateway;
    }
}
exports.ParallelGateway = ParallelGateway;
//# sourceMappingURL=ParallelGateway.js.map